import * as THREE from "three";

export const DEFAULT_SPLATS_PER_BATCH = 150000;

const QUAD_POSITIONS = new Float32Array([
  -1, -1, 0, 1, -1, 0, 1, 1, 0, -1, 1, 0,
]);

const QUAD_INDICES = new Uint16Array([0, 1, 2, 0, 2, 3]);

function createBatchGeometry(count, startIndex) {
  if (!Number.isInteger(count) || count <= 0) {
    throw new Error(`Invalid Gaussian batch count: ${count}`);
  }

  const geometry = new THREE.InstancedBufferGeometry();

  geometry.setAttribute(
    "position",
    new THREE.BufferAttribute(QUAD_POSITIONS, 3),
  );

  geometry.setIndex(new THREE.BufferAttribute(QUAD_INDICES, 1));

  const gaussianIndices = new Float32Array(count);

  for (let i = 0; i < count; i += 1) {
    gaussianIndices[i] = startIndex + i;
  }

  const indexAttribute = new THREE.InstancedBufferAttribute(gaussianIndices, 1);

  indexAttribute.setUsage(THREE.DynamicDrawUsage);

  geometry.setAttribute("gaussianIndex", indexAttribute);
  geometry.instanceCount = count;

  // Instance positions come from GPU textures rather than geometry bounds.
  geometry.boundingSphere = new THREE.Sphere(new THREE.Vector3(), Infinity);

  return geometry;
}

export function createGaussianBatches(
  count,
  splatsPerBatch = DEFAULT_SPLATS_PER_BATCH,
) {
  if (!Number.isInteger(count) || count < 0) {
    throw new Error(`Invalid Gaussian count: ${count}`);
  }

  if (!Number.isInteger(splatsPerBatch) || splatsPerBatch <= 0) {
    throw new Error(`Invalid Gaussian batch size: ${splatsPerBatch}`);
  }

  if (count === 0) {
    return [];
  }

  const batchCount = Math.ceil(count / splatsPerBatch);
  const batches = new Array(batchCount);

  for (let i = 0; i < batchCount; i += 1) {
    const start = i * splatsPerBatch;
    const batchSize = Math.min(splatsPerBatch, count - start);

    batches[i] = {
      start,
      count: batchSize,
      geometry: createBatchGeometry(batchSize, start),
    };
  }

  return batches;
}

export function disposeGaussianBatches(batches) {
  batches?.forEach((batch) => batch.geometry.dispose());
}
